export default __webpack_public_path__ + "static/media/2.2d3a8495.jpg";